import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  plus20p0vtfmu0596 as plus,
  toMutableList20rdgwi7d3cwi as toMutableList,
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { listElement2fr0t0e999y76 as listElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { plus18eogev54fmsa as plus_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { default308h22k6ofhww as default_0 } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Defaults.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  FormLayoutPreferences_Field_getInstanceniwfeoycub95 as FormLayoutPreferences_Field_getInstance,
  FormLayoutPreferences_Block_getInstance2bsp7v6nfhpj1 as FormLayoutPreferences_Block_getInstance,
} from './helpers.mjs';
import { SerializableAnnotation2h7cqfq6xt1yy as SerializableAnnotation } from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_scrollsHorizontally166yklfalehnr as get_scrollsHorizontally } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa as lensByElementAssumingSetNeverManipulates } from '../../../../../reactive/com/lightningkite/reactive/lensing/LensByElementAssumingSetNeverManipulates.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { flattenml92kmikh8fo as flatten } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HorizontalListRendererClass;
function HorizontalListRenderer() {
  if (HorizontalListRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        HorizontalListRenderer_instance = null;
        super();
        HorizontalListRenderer_instance = this;
        this.wdy_1 = false;
        this.xdy_1 = 'List';
        this.ydy_1 = ListSerializer(serializer(Unit_instance)).az().h10();
      }
      zdy() {
        return this.wdy_1;
      }
      adz() {
        return this.xdy_1;
      }
      f94() {
        return this.ydy_1;
      }
      bdz(collection, item) {
        return plus(collection, item);
      }
      cdz(collection, item) {
        return this.bdz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item);
      }
      ddz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableList(collection);
        this_0.z3(index);
        return this_0;
      }
      edz(collection, item, index) {
        return this.ddz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item, index);
      }
      fdz(readable) {
        return readable;
      }
      gdz(readable) {
        return this.fdz(readable);
      }
      hdz(mutable) {
        return mutable;
      }
      idz(mutable) {
        return this.hdz(mutable);
      }
      jdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      kdz(serializer) {
        return this.jdz(serializer);
      }
    }
    initMetadataForObject($, 'HorizontalListRenderer');
    HorizontalListRendererClass = $;
  }
  return HorizontalListRendererClass;
}
var HorizontalListRenderer_instance;
function HorizontalListRenderer_getInstance() {
  if (HorizontalListRenderer_instance === VOID)
    new (HorizontalListRenderer())();
  return HorizontalListRenderer_instance;
}
var VerticalListRendererClass;
function VerticalListRenderer() {
  if (VerticalListRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        VerticalListRenderer_instance = null;
        super();
        VerticalListRenderer_instance = this;
        this.ldz_1 = true;
        this.mdz_1 = 'List';
        this.ndz_1 = ListSerializer(serializer(Unit_instance)).az().h10();
      }
      zdy() {
        return this.ldz_1;
      }
      adz() {
        return this.mdz_1;
      }
      f94() {
        return this.ndz_1;
      }
      bdz(collection, item) {
        return plus(collection, item);
      }
      cdz(collection, item) {
        return this.bdz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item);
      }
      ddz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableList(collection);
        this_0.z3(index);
        return this_0;
      }
      edz(collection, item, index) {
        return this.ddz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item, index);
      }
      fdz(readable) {
        return readable;
      }
      gdz(readable) {
        return this.fdz(readable);
      }
      hdz(mutable) {
        return mutable;
      }
      idz(mutable) {
        return this.hdz(mutable);
      }
      jdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      kdz(serializer) {
        return this.jdz(serializer);
      }
    }
    initMetadataForObject($, 'VerticalListRenderer');
    VerticalListRendererClass = $;
  }
  return VerticalListRendererClass;
}
var VerticalListRenderer_instance;
function VerticalListRenderer_getInstance() {
  if (VerticalListRenderer_instance === VOID)
    new (VerticalListRenderer())();
  return VerticalListRenderer_instance;
}
function HorizontalSetRenderer$lens$lambda(it) {
  return toList(it);
}
function HorizontalSetRenderer$lens$lambda_0(it) {
  return toList(it);
}
function HorizontalSetRenderer$lens$lambda_1(it) {
  return toSet(it);
}
var HorizontalSetRendererClass;
function HorizontalSetRenderer() {
  if (HorizontalSetRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        HorizontalSetRenderer_instance = null;
        super();
        HorizontalSetRenderer_instance = this;
        this.odz_1 = false;
        this.pdz_1 = 'Set';
        this.qdz_1 = SetSerializer(serializer(Unit_instance)).az().h10();
      }
      zdy() {
        return this.odz_1;
      }
      adz() {
        return this.pdz_1;
      }
      f94() {
        return this.qdz_1;
      }
      rdz(collection, item) {
        return plus_0(collection, item);
      }
      cdz(collection, item) {
        return this.rdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item);
      }
      sdz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableSet(collection);
        this_0.w3(item);
        return this_0;
      }
      edz(collection, item, index) {
        return this.sdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item, index);
      }
      tdz(readable) {
        return lens(readable, HorizontalSetRenderer$lens$lambda);
      }
      gdz(readable) {
        return this.tdz(readable);
      }
      udz(mutable) {
        var tmp = HorizontalSetRenderer$lens$lambda_0;
        return mutable.tak(tmp, HorizontalSetRenderer$lens$lambda_1);
      }
      idz(mutable) {
        return this.udz(mutable);
      }
      vdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      kdz(serializer) {
        return this.vdz(serializer);
      }
    }
    initMetadataForObject($, 'HorizontalSetRenderer');
    HorizontalSetRendererClass = $;
  }
  return HorizontalSetRendererClass;
}
var HorizontalSetRenderer_instance;
function HorizontalSetRenderer_getInstance() {
  if (HorizontalSetRenderer_instance === VOID)
    new (HorizontalSetRenderer())();
  return HorizontalSetRenderer_instance;
}
function VerticalSetRenderer$lens$lambda(it) {
  return toList(it);
}
function VerticalSetRenderer$lens$lambda_0(it) {
  return toList(it);
}
function VerticalSetRenderer$lens$lambda_1(it) {
  return toSet(it);
}
var VerticalSetRendererClass;
function VerticalSetRenderer() {
  if (VerticalSetRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        VerticalSetRenderer_instance = null;
        super();
        VerticalSetRenderer_instance = this;
        this.wdz_1 = true;
        this.xdz_1 = 'Set';
        this.ydz_1 = SetSerializer(serializer(Unit_instance)).az().h10();
      }
      zdy() {
        return this.wdz_1;
      }
      adz() {
        return this.xdz_1;
      }
      f94() {
        return this.ydz_1;
      }
      rdz(collection, item) {
        return plus_0(collection, item);
      }
      cdz(collection, item) {
        return this.rdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item);
      }
      sdz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableSet(collection);
        this_0.w3(item);
        return this_0;
      }
      edz(collection, item, index) {
        return this.sdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item, index);
      }
      tdz(readable) {
        return lens(readable, VerticalSetRenderer$lens$lambda);
      }
      gdz(readable) {
        return this.tdz(readable);
      }
      udz(mutable) {
        var tmp = VerticalSetRenderer$lens$lambda_0;
        return mutable.tak(tmp, VerticalSetRenderer$lens$lambda_1);
      }
      idz(mutable) {
        return this.udz(mutable);
      }
      vdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      kdz(serializer) {
        return this.vdz(serializer);
      }
    }
    initMetadataForObject($, 'VerticalSetRenderer');
    VerticalSetRendererClass = $;
  }
  return VerticalSetRendererClass;
}
var VerticalSetRenderer_instance;
function VerticalSetRenderer_getInstance() {
  if (VerticalSetRenderer_instance === VOID)
    new (VerticalSetRenderer())();
  return VerticalSetRenderer_instance;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zdz_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.be0_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_1;
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.be0_1;
  var tmp_4 = await_0(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$3 = tmp_4;
  var tmp_5 = $this.zdz_1.gah($this.ae0_1.edz(tmp_0, tmp_3, tmp$ret$3.las().f2()), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ce0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.ce0_1.gah($this.de0_1.cdz(tmp$ret$0, default_0($this.ee0_1.sdx().edu_1)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function inner($this, module_0, selector) {
  var tmp = selector.edu_1;
  var innerSer = $this.kdz(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE());
  var tmp3_desiredSize = $this.zdy() ? FormLayoutPreferences_Block_getInstance() : FormLayoutPreferences_Field_getInstance();
  var tmp0_safe_receiver = selector.fdu_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0_safe_receiver.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.l4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_0 = tmp$ret$1;
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = plus(selector.fdu_1, new (SerializableAnnotation())('com.lightningkite.lightningdb.References', tmp1_safe_receiver.m4s_1));
  }
  var tmp2_elvis_lhs = tmp_1;
  var tmp4_annotations = tmp2_elvis_lhs == null ? selector.fdu_1 : tmp2_elvis_lhs;
  var inner = selector.copyChangingType(innerSer, tmp4_annotations, tmp3_desiredSize);
  return inner;
}
function TextView$_get_exists_$ref_ng7kb4(p0) {
  return () => p0.cba();
}
function TextView$_set_exists_$ref_8dyz5w(p0) {
  return (_this__u8e3s4) => {
    p0.bba(_this__u8e3s4);
    return Unit_instance;
  };
}
var ListRenderer$form$lambda$lambda$slambdaClass;
function ListRenderer$form$lambda$lambda$slambda() {
  if (ListRenderer$form$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, this$0, $it) {
        this.zdz_1 = $mutable;
        this.ae0_1 = this$0;
        this.be0_1 = $it;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ListRenderer$form$lambda$lambda$slambdaClass = $;
  }
  return ListRenderer$form$lambda$lambda$slambdaClass;
}
function ListRenderer$form$lambda$lambda$slambda_0($mutable, this$0, $it) {
  var i = new (ListRenderer$form$lambda$lambda$slambda())($mutable, this$0, $it);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ListRenderer$form$lambda$slambdaClass;
function ListRenderer$form$lambda$slambda() {
  if (ListRenderer$form$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, this$0, $inner) {
        this.ce0_1 = $mutable;
        this.de0_1 = this$0;
        this.ee0_1 = $inner;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ListRenderer$form$lambda$slambdaClass = $;
  }
  return ListRenderer$form$lambda$slambdaClass;
}
function ListRenderer$form$lambda$slambda_0($mutable, this$0, $inner) {
  var i = new (ListRenderer$form$lambda$slambda())($mutable, this$0, $inner);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_exists_$ref_ng7kb4_0(p0) {
  return () => p0.cba();
}
function TextView$_set_exists_$ref_8dyz5w_0(p0) {
  return (_this__u8e3s4) => {
    p0.bba(_this__u8e3s4);
    return Unit_instance;
  };
}
var ListRendererClass;
function ListRenderer() {
  if (ListRendererClass === VOID) {
    class $ {
      k20() {
        return this.zdy() ? 'Vertical ' + this.adz() : 'Horizontal ' + this.adz();
      }
      idu(module_0, selector) {
        var tmp = module_0.ydt(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        return this.zdy() ? inner_0.p1().jds(VOID, inner_0.p1().gds_1 * 10 + 3) : inner_0.p1().jds((inner_0.p1().fds_1 + 3) * 10 + 3);
      }
      ldu(module_0, selector) {
        var tmp = module_0.ydt(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, _unused_var__etf5q3, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(false);
          view.xbm(this.zdy());
          if (!view.ub8_1) {
            view.ibb(get_expanding(view), get_scrollsHorizontally(view));
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_exists_$ref_ng7kb4(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('exists', 0, tmp, tmp_0, TextView$_set_exists_$ref_8dyz5w(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.baj(mutable);
            var tmp$ret$0 = ((!(tmp == null) ? isInterface(tmp, Collection()) : false) ? tmp : THROW_CCE()).i1();
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_1 = view_0.tb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = 'Empty';
          }
          tmp_1.fbu(tmp_2);
          view.fbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.ebb(p_1, view_1);
          view_1.xbm(false);
          view_1.xbm(this.zdy());
          var tmp_3 = lensByElementAssumingSetNeverManipulates(this.idz(mutable));
          forEachUpdating(view_1, tmp_3, VOID, ($this$forEachUpdating, it) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp = $this$forEachUpdating.hbb(CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())($this$forEachUpdating.pc());
            var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
            $this$forEachUpdating.ebb(p, view);
            view.xbm(false);
            view.zb8(get_px(0));
            if (this.zdy()) {
              get_expanding(view);
            }
            inner_0.tds()(view, null, flatten(it));
            var tmp_0 = get_centered(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Button())(view.pc());
            var tmp0_elvis_lhs_0 = view.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.ebb(p_0, view_0);
            icon(view_0, Companion_getInstance().tcf_1.gd5(get_rem(1), get_rem(1)), 'Delete');
            onClick(view_0, VOID, VOID, ListRenderer$form$lambda$lambda$slambda_0(mutable, this, it));
            view.fbb(p_0, view_0);
            view.jbb(tmp_0, view_0);
            $this$forEachUpdating.fbb(p, view);
            $this$forEachUpdating.jbb(tmp, view);
            return Unit_instance;
          });
          view.fbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view.pc());
          var tmp0_elvis_lhs_2 = view.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.ebb(p_2, view_2);
          if (this.zdy()) {
            var tmp_4 = get_centered(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (RowOrCol())(view_2.pc());
            var tmp0_elvis_lhs_3 = view_2.cbb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
            view_2.ebb(p_3, view_3);
            view_3.xbm(false);
            view_3.jbb(get_centered(view_3), text(view_3, 'Add'));
            view_3.jbb(get_centered(view_3), icon(view_3, Companion_getInstance().wcf_1.gd5(get_rem(1), get_rem(1)), ''));
            view_2.fbb(p_3, view_3);
            view_2.jbb(tmp_4, view_3);
          } else {
            view_2.jbb(get_centered(view_2), icon(view_2, Companion_getInstance().wcf_1.gd5(get_rem(1), get_rem(1)), 'Add'));
          }
          onClick(view_2, VOID, VOID, ListRenderer$form$lambda$slambda_0(mutable, this, inner_0));
          view.fbb(p_2, view_2);
          $this$FormRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      ndu(module_0, selector) {
        var tmp = module_0.zdt(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, ViewRenderer()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, _unused_var__etf5q3, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.ebb(p, view);
          view.xbm(false);
          view.xbm(this.zdy());
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_exists_$ref_ng7kb4_0(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('exists', 0, tmp, tmp_0, TextView$_set_exists_$ref_8dyz5w_0(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.baj(readable);
            var tmp$ret$0 = ((!(tmp == null) ? isInterface(tmp, Collection()) : false) ? tmp : THROW_CCE()).i1();
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_1 = view_0.tb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = 'Empty';
          }
          tmp_1.fbu(tmp_2);
          view.fbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.ebb(p_1, view_1);
          view_1.xbm(false);
          view_1.xbm(this.zdy());
          var tmp_3 = this.gdz(readable);
          forEachUpdating(view_1, tmp_3, VOID, ($this$forEachUpdating, it) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp$ret$7 = $this$forEachUpdating.hbb(CardSemantic_getInstance());
            $this$forEachUpdating.jbb(tmp$ret$7, inner_0.tds()($this$forEachUpdating, null, it));
            return Unit_instance;
          });
          view.fbb(p_1, view_1);
          $this$ViewRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, 'ListRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ListRendererClass = $;
  }
  return ListRendererClass;
}
//region block: exports
export {
  HorizontalListRenderer_getInstance as HorizontalListRenderer_getInstance2a2d2yjt2ymkp,
  HorizontalSetRenderer_getInstance as HorizontalSetRenderer_getInstance3gkefggjyyvww,
  VerticalListRenderer_getInstance as VerticalListRenderer_getInstance4zt7v1o9ou4j,
  VerticalSetRenderer_getInstance as VerticalSetRenderer_getInstance3io8tjnf253ym,
};
//endregion

//# sourceMappingURL=ListRenderer.mjs.map
